import type {
  PathLookupGraphPreset,
  PathLookupGraphSettings,
  TopologyGraphPreset,
  TopologyGraphSettings,
} from '@ipfabric/utils';
import { extractPresetSettings } from 'components/Graph/helpers/extractPresetSettings';

export const mergeSettingsToPreset = (
  settings: TopologyGraphSettings | PathLookupGraphSettings,
  preset: TopologyGraphPreset | PathLookupGraphPreset,
): TopologyGraphPreset | PathLookupGraphPreset => ({
  ...preset,
  ...extractPresetSettings(settings),
});
